"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyChecklistValue = void 0;
const getEmptyChecklistValue = () => {
    return {
        items: [],
        total_items: 0,
        completed_items: 0,
    };
};
exports.getEmptyChecklistValue = getEmptyChecklistValue;
